enum PlanStatus {
  Pending = 'P',
  Approved = 'A',
  Rejected = 'R',
}

export default PlanStatus;
